import config from 'siteconfig';

// This is the TZ we operate from for purposes of the website
const timeZone = 'America/New_York';

// Generate the full path from a date and slug
const getRoute = ({ publishedAt, slug }) => {
  const date = new Date(publishedAt);

  const year = date.toLocaleString('en-US', { year: 'numeric', timeZone });
  const month = date.toLocaleString('en-US', { month: '2-digit', timeZone });
  const day = date.toLocaleString('en-US', { day: '2-digit', timeZone });

  const dateSegment = `${year}/${month}/${day}`;
  return `/${config.blog.baseURL}/${dateSegment}/${slug}`;
};

// Will generate a og image compatible url from a path and params
const getOpenGraphUrl = (path, params) => {
  const dynamicOpenGraphUrl = new URL(`${config.siteUrl}${path}`);

  // For each param in params, append to the searchParams of dynamicOpenGraphUrl
  Object.keys(params).forEach((key) => {
    dynamicOpenGraphUrl.searchParams.append(key, params[key]);
  });

  return dynamicOpenGraphUrl.href;
};

// amendment.app referral URL with UTM attribution for Resistbot → Amendment tracking.
const getAmendmentUrl = (path, campaign) => {
  const url = new URL(`${config.miscUrls.amendment}${path}`);
  url.searchParams.set('utm_source', 'resistbot');
  url.searchParams.set('utm_medium', 'referral');
  url.searchParams.set('utm_campaign', campaign);
  return url.href;
};

export { getAmendmentUrl, getOpenGraphUrl, getRoute };
